export default __webpack_public_path__ + "static/media/body-mass-index.303cd76b.svg";